// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2cLiU","fileBtn":"File_fileBtn___jEL3","closeBtn":"File_closeBtn__3biEa","fileSelected":"File_fileSelected__3hz5A","disabled":"File_disabled__1Ntpi"};